<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Nazioni"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="2">
              <span class='label'>
                Acronimo
              </span>
            </b-col>
            <b-col cols="8">
              <span class='label'>
                Nazione
              </span>
            </b-col>
            <b-col cols="2">
              <span class='label'>
                Attiva
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-form-input v-model="form_data.acronym" class=""></b-form-input>
            </b-col>
            <b-col cols="8">
              <b-form-input v-model="form_data.nation" class=""></b-form-input>
            </b-col>
            <b-col cols="2">
              <b-form-checkbox v-model="form_data.active" class="" style="height: 2rem;width: 2rem;"></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelNation">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertNation">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateNation">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Nazioni"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <b-table
                :items="nations"
                :fields="nations_fields"
                :per-page="perPage"
                :current-page="currentPage"
                v-model:sort-by="sortBy"
                v-model:sort-desc="sortDesc"
                @row-clicked="selectNation"
                @sort-changed="onSortChanged"
              >
                <template #cell(id)="data">
                  <span style="display:none">
                    {{ data.item.id }}
                  </span>
                </template>
                <template #cell(active)="data">
                  <i v-if="data.item.active" class="fa-classic fa-solid fa-check fa-fw" style="color: darkgreen;"></i>          
                </template>
              </b-table>
            </b-col>
            <b-col cols="10">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  @change="onPageChange"
                  class="my-3"
                ></b-pagination>
            </b-col>
            <b-col cols="2" style="margin-top: 1.5rem;">
                <b-form-select v-model="perPage" :options="[5, 10, 15, 20]" class="mb-3" style="width: 6rem;" @change="onPerPageChange"></b-form-select>
            </b-col>            
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

</div>